import { render, staticRenderFns } from "./uploadVideos.vue?vue&type=template&id=0110fc20&scoped=true&"
import script from "./uploadVideos.vue?vue&type=script&lang=js&"
export * from "./uploadVideos.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideos.vue?vue&type=style&index=0&id=0110fc20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110fc20",
  null
  
)

export default component.exports